const fr = {
  language: 'Français',
  hero: {
    headline: 'Centre Al Salama de Hijama',
    subtitle: 'Un soin naturel pour votre bien-être',
    cta: 'Réserver maintenant'
  },
  benefits: {
    title: 'Les bienfaits',
    items: [
      'Stimule la circulation sanguine',
      'Soulage la douleur',
      "Renforce l'immunité",
      'Détoxifie le corps',
      'Relaxation et réduction du stress',
      'Améliore la santé globale'
    ]
  },
  howItWorks: {
    title: 'Comment ça marche ?',
    steps: [
      'Consultation initiale',
      'Application des ventouses',
      'Soins post-séance'
    ]
  },
  testimonials: {
    title: 'Témoignages',
    items: [
      { name: 'Ahmed', text: 'Expérience formidable ! Je me sens beaucoup mieux.' },
      { name: 'Sarah', text: 'Service professionnel et résultats impressionnants.' },
      { name: 'Youssef', text: 'Accueil chaleureux et résultats visibles dès la première séance.' }
    ]
  },
  about: {
    title: 'À propos du praticien',
    text: 'Praticien expert en hijama médicale\net thérapies naturelles'
  },
  pricing: {
    title: 'Tarifs',
    moreButton: 'Voir plus'
  },
  services: {
    session1: {
      title: 'Hijama humide',
      shortDesc: 'Hijama traditionnelle',
      price: '100 dh',
      img: 'price1.png',
      longDesc: `La hijama humide est une méthode thérapeutique traditionnelle qui consiste à faire de petites incisions superficielles sur la peau puis à aspirer le sang stagnant à l'aide de ventouses (aspiration).

Bénéfices :
- Purification du corps des toxines
- Stimulation de la circulation sanguine
- Soulagement des douleurs chroniques (dos, tête, articulations)
- Renforcement de l'immunité

Utilisée pour : maux de tête, fatigue chronique, douleurs musculaires, troubles digestifs, douleurs menstruelles, etc.`
    },
    session2: {
      title: 'Serviette de feu',
      shortDesc: 'Stimulation de la circulation sanguine',
      price: '80 dh',
      img: 'price2.png',
      longDesc: `Technique traditionnelle consistant à chauffer une serviette imbibée d'alcool et à l'appliquer rapidement sur le dos, aidant à détendre les muscles et à stimuler la circulation sanguine.

Bénéfices :
- Détente rapide des spasmes musculaires
- Sensation de chaleur et de relaxation profonde
- Stimulation de la circulation locale
- Soulagement des tensions du dos et des épaules

Utile pour : stress, douleurs musculaires, raideur du dos.`
    },
    session3: {
      title: 'Massage thérapeutique',
      shortDesc: 'Massage',
      price: '80 dh',
      img: 'price3.png',
      longDesc: `Séance de massage manuel ciblant les zones de tension du corps, aide à la relaxation musculaire et à la réduction du stress.

Bénéfices :
- Réduction du stress et de l'anxiété
- Amélioration de la qualité du sommeil
- Soulagement des douleurs du cou, du dos et des muscles
- Relaxation générale du corps et de l'esprit

Indiqué pour : fatigue, douleurs musculaires, insomnie, stress.`
    },
    special: {
      title: 'Offre complète',
      shortDesc: 'Hijama + massage + serviette de feu',
      price: '150 dh',
      img: 'price4.png',
      longDesc: `Comprend :
- Hijama humide
- Serviette de feu
- Massage thérapeutique

Avantages :
Une séance complète qui combine purification du corps, relaxation musculaire et stimulation de la circulation sanguine.

Pour qui ?
Idéal pour les personnes très fatiguées ou stressées, souhaitant une séance de récupération globale.`
    }
  },
  faq: {
    title: 'FAQ',
    questions: [
      { q: 'La cupping est-elle douloureuse ?', a: 'Généralement non, vous pouvez ressentir une légère aspiration.' },
      { q: 'Combien de séances sont nécessaires ?', a: 'Cela dépend de votre état, souvent 1 à 3 séances suffisent.' }
    ]
  },
  finalCta: {
    text: 'Réservez votre séance ou contactez-nous via WhatsApp ou téléphone.'
  },
  footer: {
    contact: 'Contact',
    location: 'Localisation',
    follow: 'Suivez-nous'
  },
  serviceDetailsDescLabel: "Description",
  serviceDetailsLongDescLabel: "Détails"
};

export default fr;
